import { createI18n } from 'vue-i18n'
import en from '../locales/en.json'
import zh from '../locales/zh.json'
import ar from '../locales/ar.json'
import es from '../locales/es.json'

export default defineNuxtPlugin((nuxtApp) => {
  const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
      en,
      zh,
      ar,
      es,
    },
    missing: (locale, key) => {
      return key
    },
  })

  nuxtApp.vueApp.use(i18n)

  return {
    provide: {
      i18n: i18n.global,
    },
  }
})
